import { useReducer } from 'react'
import { AnimatePresence } from 'motion/react'
import FeedbacksContext from '../context/feedbacks/FeedbacksContext'
import { feedbacksReducer } from '../context/feedbacks/feedbacksReducer'
import { feedbacksInitialState } from '../context/feedbacks/feedbacksInitialState'
import useFeedbackPopup from '../hooks/useFeedbackPopup'
import FeedbackPopupCard from './FeedbackPopupCard'
import FeedbackPopupTab from './FeedbackPopupTab'

export default function FeedbackPopup() {
  const [feedbacksState, feedbacksDispatch] = useReducer(feedbacksReducer, feedbacksInitialState)
  const { isOpen, open, close, submitted, markSubmitted } = useFeedbackPopup()

  return (
    <FeedbacksContext.Provider value={{ feedbacksState, feedbacksDispatch }}>
      <FeedbackPopupCard
        isOpen={isOpen}
        onClose={close}
        onSubmitted={markSubmitted}
      />
      <AnimatePresence>
        {!isOpen && !submitted && (
          <div className="fixed bottom-2 left-2 z-10">
            <FeedbackPopupTab onClick={open} />
          </div>
        )}
      </AnimatePresence>
    </FeedbacksContext.Provider>
  )
}
